/**
 * 언어 코드를 사람이 읽는 이름으로.
 * Intl.DisplayNames 가 있으면 현재 로케일 기준으로 번역해 보여준다.
 */

const FALLBACK_NAMES: Record<string, string> = {
  ko: '한국어',
  en: '영어',
  ja: '일본어',
  zh: '중국어',
  es: '스페인어',
  de: '독일어',
  fr: '프랑스어',
  pt: '포르투갈어',
  vi: '베트남어',
  id: '인도네시아어',
  ru: '러시아어',
  th: '태국어',
}

/** 예: 'ko' → '한국어 (ko)'. 알 수 없으면 코드 그대로. */
export function languageLabel(code: string, locale = 'ko'): string {
  if (!code || code === 'Unknown') {
    return code
  }

  try {
    const display = new Intl.DisplayNames([locale], { type: 'language' })
    const name = display.of(code)
    if (name && name.toLowerCase() !== code.toLowerCase()) {
      return `${name} (${code})`
    }
  } catch {
    // Intl.DisplayNames 미지원 환경 — 아래 폴백 사용
  }

  const fallback = FALLBACK_NAMES[code.toLowerCase()]
  return fallback ? `${fallback} (${code})` : code
}

export default languageLabel
